import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-label="Money-back guarantee" className="bg-white" data-id="element-97" data-mp="1o46konudlsx5">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center lg:py-20" style={{
      paddingTop: "11px",
      paddingBottom: "23px"
    }} data-id="element-98" data-mp="1o5zs45ctch67">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-perf/15" data-id="element-99" data-mp="1x5d1ky0xt5qx">
          <ShieldCheckIcon className="h-8 w-8 text-perf-deep" aria-hidden="true" data-id="element-100" data-mp="19fsi8e0vg6h4" />
        </span>
        <h2 className="mt-6 font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-101" data-mp="14gpeqy0ji8b9">
          7-Day Money-Back Guarantee
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-navy/75" data-id="element-102" data-mp="1edu394huyfv8">
          If during the first 7 days you decide that THE FULL DISTANCE TRIATHLON SYSTEM™ isn't the right
          fit for your needs, request a refund according to the guarantee terms and receive 100% of your
          purchase price back.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-navy/75" data-id="element-103" data-mp="p0b8nz95nghj">
          You can explore the system without taking a long-term financial risk.
        </p>
        <p className="mt-6 text-sm font-bold uppercase tracking-[0.2em] text-navy" data-id="element-104" data-mp="tw9qf3zza08z">
          Sigma Smart™ stands behind the quality of the system.
        </p>
      </div>
    </section>;
}